module.exports = __webpack_public_path__ + "static/moti-frontal-3e300239f73f243763b256cef5f778ee.png";